"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWSToolsGalleryTagsDataComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-gallery-tags-data">
    ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.tagsData) === null || _a === void 0 ? void 0 : _a.length) > 0; }, (0, fast_element_1.html) `
        <div class="tags-container">
            ${(0, fast_element_1.repeat)(x => x.tagsData, (0, fast_element_1.html) `
                <span class="tag-item">
                    <i class="simple-icon-picture"></i>
                    ${tag => tag}
                </span>
            `)}
        </div>
    `)}

    ${(0, fast_element_1.when)(x => { var _a; return !((_a = x.tagsData) === null || _a === void 0 ? void 0 : _a.length); }, (0, fast_element_1.html) `
        <div class="empty-state">
            <span class="empty-icon">🖼️</span>
            <p>${'galleryTags.noTags'.t()}</p>
        </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rws-tools-gallery-tags-data {
  border-radius: 12px;
}
.rws-tools-gallery-tags-data .tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}
.rws-tools-gallery-tags-data .tags-container .tag-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: var(--success-color, #28a745);
  color: white;
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 0.85rem;
  font-weight: 500;
}
.rws-tools-gallery-tags-data .tags-container .tag-item i {
  font-size: 0.75rem;
}
.rws-tools-gallery-tags-data .empty-state {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-gallery-tags-data .empty-state .empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  display: block;
  opacity: 0.7;
}
.rws-tools-gallery-tags-data .empty-state p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.rws-tools-gallery-tags-data .empty-state .empty-suggestion {
  color: var(--text-tertiary, #9ca3af);
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 8px;
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-container {
  background: var(--bg-secondary-dark, #2d3748);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-list-item {
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-list-item .item-title {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-list-item .item-subtitle {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-list-item .item-description {
  color: var(--text-secondary-dark, #a0aec0);
  border-top-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-list-item:hover {
  background: var(--bg-hover-dark, #4a5568);
  border-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-list-item:hover::after {
  background: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-query-display {
  background: var(--bg-secondary-dark, #2d3748);
  border-left-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-query-display .query-label {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-query-display .query-text {
  color: var(--text-primary-dark, #f7fafc);
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-results-summary {
  background: var(--success-color-dark-bg, #1e4d2b);
  border-color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-results-summary .results-count {
  color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-empty-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-empty-state p {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-empty-state .empty-suggestion {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-loading-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-gallery-tags-data .tool-loading-state .spinner {
  border-color: var(--border-color-dark, #4a5568);
  border-top-color: var(--primary-color-dark, #63b3ed);
}
@media (max-width: 768px) {
  .rws-tools-gallery-tags-data {
    padding: 16px;
    margin: 12px 0;
  }
  .rws-tools-gallery-tags-data h3 {
    font-size: 1.1rem;
  }
  .rws-tools-gallery-tags-data h4 {
    font-size: 0.95rem;
  }
  .rws-tools-gallery-tags-data .tool-container {
    padding: 12px;
  }
  .rws-tools-gallery-tags-data .tool-list-item {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .rws-tools-gallery-tags-data .tool-list-item .item-title {
    font-size: 0.9rem;
  }
  .rws-tools-gallery-tags-data .tool-list-item .item-description {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .rws-tools-gallery-tags-data .tool-empty-state {
    padding: 24px 12px;
  }
  .rws-tools-gallery-tags-data .tool-empty-state .empty-icon {
    font-size: 2rem;
  }
  .rws-tools-gallery-tags-data .tool-empty-state p {
    font-size: 0.9rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let RWSToolsGalleryTagsDataComponent = class RWSToolsGalleryTagsDataComponent extends client_1.RWSViewComponent {
};
exports.RWSToolsGalleryTagsDataComponent = RWSToolsGalleryTagsDataComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], RWSToolsGalleryTagsDataComponent.prototype, "tagsData", void 0);
exports.RWSToolsGalleryTagsDataComponent = RWSToolsGalleryTagsDataComponent = __decorate([
    (0, client_1.RWSView)('rws-tools-gallery-tags-data', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RWSToolsGalleryTagsDataComponent);
RWSToolsGalleryTagsDataComponent.defineComponent();
